import axios from '@/libs/api.request'

// 获取订单列表
export const getOrderList = (data) => {
    return axios.request({
      url: 'order/page',
      data: data,
      method: 'post',
    })
}

// 获取订单详情
export const getOrderDetail = (id) => {
    return axios.request({
      url: `v2/orders/${id}`,
      method: 'get',
    })
}

// 订单筛选（增强版）
export const filterOrders = (data) => {
    return axios.request({
      url: 'v2/orders/filter',
      data: data,
      method: 'post',
    })
}

// 订单统计
export const getOrderStatistics = (data) => {
    return axios.request({
      url: 'v2/orders/statistics',
      data: data,
      method: 'post',
    })
}

// 订单导出
export const exportOrders = (data) => {
    return axios.request({
      url: 'v2/orders/export',
      data: data,
      method: 'post',
      responseType: 'blob',
    })
}

// 批量更新订单状态
export const batchUpdateOrders = (data) => {
    return axios.request({
      url: 'v2/orders/batch-update',
      data: data,
      method: 'post',
    })
}